import { TableColumnDefinition } from '../table/table-column-definition'

export const ReddiGraphTableColumnDefinition: TableColumnDefinition[] = [
  {
    columnName: 'age',
    columnWidth: '26px',
    columnTextAlign: 'right',
    header: 'Age in Months',
    sortDisabled: true,
    columnType: 'string',
  },
  {
    columnName: 'presentationDate',
    columnWidth: '36px',
    columnTextAlign: 'left',
    header: 'Date',
    sortDisabled: true,
    columnType: 'string',
  },
  {
    columnName: 'l_m',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'm',
    sortDisabled: true,
    iconColor: '#ff0000',
    linkText: 'x',
    columnType: 'background-color',
  },
  {
    columnName: 'l_or',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'or',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'l_oo',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'oo',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'l_ah',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ah',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'l_ee',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ee',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'l_sh',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'sh',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'l_s',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 's',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'empty_l',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: '--',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_m',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'm',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_or',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'or',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_oo',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'oo',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_ah',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ah',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_ee',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ee',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_sh',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'sh',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'r_s',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 's',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'empty_r',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: '--',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_m',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'm',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_or',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'or',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_oo',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'oo',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_ah',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ah',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_ee',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'ee',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_sh',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 'sh',
    sortDisabled: true,
    columnType: 'background-color',
  },
  {
    columnName: 'e_s',
    columnWidth: '20px',
    columnTextAlign: 'center',
    header: 's',
    sortDisabled: true,
    columnType: 'background-color',
  },
  // {
  //   columnName: 'orderCounter',
  //   columnWidth: '10px',
  //   columnTextAlign: 'center',
  //   header: 'order',
  //   sortDisabled: true,
  //   columnType: 'string',
  // }
]
